var exports = {
  "X": "BetaLabel__IKlSz5",
  "v": "TestButton__wT5YcC",
};

module.exports = exports;
